import { addDoc, collection } from "firebase/firestore"
import { encrypt } from "./encryption"
import { auth, db } from "./firebase"

export async function submitOrder(order) {

    if(order?.items?.length === 0) {
        throw Error("Cart is empty")
    }

    const data = await encrypt(order)

    return await addDoc(collection(db, "orders"), {
        data,
        user: auth.currentUser.uid,
        status: "pending",
    })
}